import { tryAxios } from '@/api/common/auth'
import { enLookupType, enFirstType } from '@/configs/enums'
import { urlPrefix } from '@/configs/api'
// import sysLocalStorage from '@/store/localStorage'

const apiUrl = `${urlPrefix}/selects`
//#region select数据源相关api
//对每个页面返回各自的Api数据源集合
const GetDataSource = `${apiUrl}/GetDataSource`
export const getDataSource = (path: any) => {
    return tryAxios({
        method: 'get',
        url: GetDataSource,
        params: { path: path ? path : '' }
    })
}
const GetDataBoardSource = `${apiUrl}/GetDataBoardSource`
export const getDataBoardSource = () => {
    return tryAxios({
        method: 'get',
        url: GetDataBoardSource
    })
}
const GetCommonData = `${apiUrl}/GetCommonData`
export const getCommonData = () => {
    return tryAxios({
        method: 'get',
        url: GetCommonData
    })
}
const GetLookupGroups = `${apiUrl}/GetLookupGroups`
const GetLookupTypeByGroup = `${apiUrl}/GetLookupTypeByGroup`
const GetParentTypes = `${apiUrl}/GetParentTypes`
const GetCitysByUser = `${apiUrl}/GetCitysByUser`
const GetLookupByType = `${apiUrl}/GetLookupByType`
const GetLookupChilds = `${apiUrl}/GetLookupChilds`
const GetInstitutes = `${apiUrl}/GetInstitutes`
const GetAreaType = `${apiUrl}/GetAreaType`
const GetCityByProvince = `${apiUrl}/GetCityByProvince`
const GetPositionType = `${apiUrl}/GetPositionType`
const GetProjectPhase = `${apiUrl}/GetProjectPhase`
const GetUserTypes = `${apiUrl}/GetUserTypes`
const GetSubTypes = `${apiUrl}/GetUserSubTypes`
const GetUserTypeInCruise = `${apiUrl}/GetUserTypeInCruise`

const GetHiddenDanger = `${apiUrl}/GetHiddenDanger`
//批文年份
const GetOfficialDocYears = `${apiUrl}/GetOfficialDocYears`
//批文类型
const GetOfficialDocTypes = `${apiUrl}/GetOfficialDocTypes`
//公开形式 主动公开，依申请公开，不公开
const GetOfficialDocPublicTypes = `${apiUrl}/GetOfficialDocPublicTypes`
//批复类型 1规划，2方案，3立项
const GetOfficialDocCategories = `${apiUrl}/GetOfficialDocCategories`
//性别
const GetGender = `${apiUrl}/GetGender`

//保护工程
//实施项目 方案设计阶段
const GetUnitProjectProposalPhase = `${apiUrl}/GetUnitProjectProposalPhase`
//实施项目 保护工程进展
const GetUnitProjectPhase = `${apiUrl}/GetUnitProjectPhase`
//#endregion

export interface DDLItem {
    Key: number,
    Val: string,
    ExInfo: {
        Code: string
        Flag1: boolean
        Flag2: boolean
        Explain: string
    },
    SubList: DDLItem[]
}
export interface DDL2Item {
    Key: string,
    Val: string
}

export const CustomDDLItem = (firstText: string): DDLItem => {
    const item: DDLItem = {
        Key: 0,
        Val: firstText,
        ExInfo: {
            Code: '',
            Flag1: false,
            Flag2: false,
            Explain: ''
        },
        SubList: []
    }
    return item
}
export const DefDDLItem = (firstType: number): DDLItem => {
    let firstText = ''
    switch (firstType) {
        case enFirstType.All:
            firstText = '--全部--'
            break
        case enFirstType.Select:
            firstText = '--请选择--'
            break
        default:
            firstText = ''
    }
    const item: DDLItem = CustomDDLItem(firstText)
    return item
}
//#region 批文
export const getOfficialDocYears = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetOfficialDocYears,
        params: { type: firstType }
    })
}
//category 0.所有批文 1.立项批文Resvered_Flag1=true，2.批复/意见文号(Resvered_Flag2=true 冀文物发、文物保函、办保函)
export const getOfficialDocTypes = (category: number, firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetOfficialDocTypes,
        params: {
            category: category,
            firstType: firstType
        }
    })
}
//公开形式 主动公开，依申请公开，不公开
export const getOfficialDocPublicTypes = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetOfficialDocPublicTypes,
        params: { type: firstType }
    })
}
//批复类型1规划，2方案，3立项
export const getOfficialDocCategories = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetOfficialDocCategories,
        params: { type: firstType }
    })
}
//#endregion
//性别：1男 2女
export const getGender = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetGender,
        params: { type: firstType }
    })
}
//#region 保护工程
export const getUnitProjectProposalPhase = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetUnitProjectProposalPhase,
        params: { type: firstType }
    })
}
export const getUnitProjectPhase = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetUnitProjectPhase,
        params: { type: firstType }
    })
}
//#endregion
export const getUserTypes = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetUserTypes,
        params: { type: firstType }
    })
}
export const getSubTypes = (userType: number, firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetSubTypes,
        params: { userType, firstType }
    })
}
// 巡查计划中的用户类型
export const getUserTypeInCruise = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetUserTypeInCruise,
        params: { type: firstType }
    })
}
// 父级 LookupType 在上下级关系表中用到
export const getProjectPhase = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetProjectPhase,
        params: { type: firstType }
    })
}
// 城市查询
export const getCityByProvince = (province: number, firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetCityByProvince,
        params: {
            provinceId: province,
            type: firstType
        }
    })
}
// 父级 LookupType 在上下级关系表中用到
export const getParentTypes = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetParentTypes,
        params: { type: firstType }
    })
}

// LookupType 分组 在基础数据维护中用到
export const getLookupGroups = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetLookupGroups,
        params: { type: firstType }
    })
}

// 通过分组名查询 LookupType 在基础数据维护中用到
export const getLookupTypeByGroup = (groupName: string, firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetLookupTypeByGroup,
        params: { group: groupName, type: firstType }
    })
}

// 通用方法，通过类型获取Lookup表数据
export const getLookupByType = (lookupType: number, firstType: number) => {
    const typeToString = enLookupType[lookupType]
    return tryAxios({
        method: 'get',
        url: GetLookupByType,
        params: {
            lookupType: typeToString ? typeToString : '',
            type: firstType
        }
    })
}

export const getLookupChilds = (parentLookupId: number, childLookupType: number, firstType: number) => {
    const typeToString = enLookupType[childLookupType]
    return tryAxios({
        method: 'get',
        url: GetLookupChilds,
        params: {
            parentId: parentLookupId,
            childType: typeToString ? typeToString : '',
            type: firstType
        }
    })
}
// 评审机构
export const getInstitutes = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetInstitutes,
        params: { type: firstType }
    })
}

// 用户在自己权限内能看到的城市，里面包含了其下辖县，可以通过 getDDLChild(list,key) 来获取对应子级
export const getCitysByUser = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetCitysByUser,
        params: { type: firstType }
    })
}

// 问题上报中的隐患问题，里面包含了子类型，可以通过 getDDLChild(list,key) 来获取对应子级
export const getHiddenDanger = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetHiddenDanger,
        params: { type: firstType }
    })
}

//#region 文保单位相关数据
// 坐标类型
export const getPositionType = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetPositionType,
        params: { type: firstType }
    })
}
// 区域类型
export const getAreaType = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetAreaType,
        params: { type: firstType }
    })
}
// 单位级别
export const getHeritageLevel = (firstType: number) => {
    return getLookupByType(enLookupType.HeritageLevel, firstType)
}
// 批次
export const getHeritageBatch = (firstType: number) => {
    return getLookupByType(enLookupType.HeritageBatch, firstType)
}
// 文物分类
export const getHeritageClassify = (firstType: number) => {
    return getLookupByType(enLookupType.HeritageClassify, firstType)
}
// 文物子类
export const getHeritageSubClassify = (parentId: number, firstType: number) => {
    return getLookupChilds(parentId, enLookupType.HeritageSubClassify, firstType)
}
// 机构类型
export const getInstituteType = (firstType: number) => {
    return getLookupByType(enLookupType.InstituteType, firstType)
}
// 机构类型
export const getHeritageAge = (firstType: number) => {
    return getLookupByType(enLookupType.HeritageAge, firstType)
}
//#endregion

//#region 用户表中的专家信息
// 学历
export const getEducations = (firstType: number) => {
    return getLookupByType(enLookupType.Education, firstType)
}
// 专家职称
export const getExpertPositionals = (firstType: number) => {
    return getLookupByType(enLookupType.Positional, firstType)
}
//#endregion

//#region 用户表中的文保单位责任主体 这里的部门和职位是否应该有联动
// 部门
export const getRspbltyDepartments = (firstType: number) => {
    return getLookupByType(enLookupType.ResponsibilityDepartment, firstType)
}
// 职位
export const getRspbltyPositions = (firstType: number) => {
    return getLookupByType(enLookupType.ResponsibilityPosition, firstType)
}
//#endregion
